module.exports = __webpack_public_path__ + "img/zhuhai_door.a3789728.jpg";